import type { Brand, Market } from '@org-avp/models';
import type { MutableRefObject } from 'react';

export enum StreamingStage {
  DEV = 'dev',
  QA = 'qa', // Deprecated in future
  QA_EUW = 'qa-euw1',
  PRELIVE = 'prelive',
  PRELIVE_EUC1 = 'prelive-euc1',
  PRELIVE_EUW1 = 'prelive-euw1',
  SANDBOX = 'sandbox',
  PROD_EUC1 = 'prod-euc1',
  PROD_EUW1 = 'prod-euw1',
  PROD_EUN1 = 'prod-eun1',
  PROD_USE1 = 'prod-use1',
  PROD_USW2 = 'prod-usw2',
  PROD_APSE1 = 'prod-apse1',
}

export enum StreamingState {
  ERROR = 'error',
  LOADING = 'loading',
  CONNECTED = 'ready',
  STOPPED = 'stopped',
  INITIAL = 'initial',
}

export type ShowroomFeatures = Partial<{
  animationSpots: boolean;
  animations: boolean;
  cameraFlight: boolean;
  cameraNavigation: boolean;
  close: boolean;
  environments: boolean;
  fullscreen: boolean;
  interior: boolean;
  zoom: boolean;
}>;

export type DeckConnectedEventDetail = {
  sessionId: number;
};

export interface DeckElementEventMap extends HTMLElementEventMap {
  connected: CustomEvent<DeckConnectedEventDetail>;
  disconnected: CustomEvent<DeckDisconnectedEventDetail>;
  exception: CustomEvent<DeckOnExceptionEventDetail>;
  initialized: CustomEvent;
}

export enum DeckDisconnectedEventReason {
  DISCONNECTED = 'DISCONNECTED',
  MULTISESSION_DISCONNECTED = 'MULTISESSION_DISCONNECTED',
  INACTIVITY_TIMEOUT = 'INACTIVITY',
}

export enum DeckExceptionReason {
  UNKNOWN_EXCEPTION = 'UNKNOWN_EXCEPTION',
  AVE_CAR_NOT_INSTALLED = 'AVE_CAR_NOT_INSTALLED',
  AVE_ENVIRONMENT_NOT_INSTALLED = 'AVE_ENVIRONMENT_NOT_INSTALLED',
  NO_INSTANCES_AVAILABLE = 'NO_INSTANCES_AVAILABLE',
  PR_STRING_NOT_PROVIDED = 'PR_STRING_NOT_PROVIDED',
  CONFIGURATION_ERROR = 'CONFIGURATION_ERROR',
  BRAND_NOT_PROVIDED = 'BRAND_NOT_PROVIDED',
  BRAND_NOT_SUPPORTED = 'BRAND_NOT_SUPPORTED',
  SERVICE_NOT_PROVIDED = 'SERVICE_NOT_PROVIDED',
  MARKET_NOT_PROVIDED = 'MARKET_NOT_PROVIDED',
}

export const StreamingErrorReasonsSet = new Set<string>(
  Object.values(DeckExceptionReason) as DeckExceptionReason[],
);

export type DeckOnExceptionEventDetail = {
  error: Error;
  message: string;
  type: 'exception';
  reason?: DeckExceptionReason | string;
};

export type DeckDisconnectedEventDetail = {
  reason: DeckDisconnectedEventReason;
};

export type WebstreamingWebComponentProps = {
  brand: Brand;
  market: Market;
  'config-id': string;
  'pr-string': string;
  'streaming-stage': StreamingStage | '';
  environments?: Array<string>;
  dayEnvironment?: string;
  nightEnvironment?: string;
  active: boolean;
  service?: string;
  template?: string;
  ref?: MutableRefObject<HTMLElement | undefined>;
  features?: ShowroomFeatures;
  connected?: (event: CustomEvent<DeckConnectedEventDetail>) => void;
  disconnected?: (event: CustomEvent<DeckDisconnectedEventDetail>) => void;
  exception?: (error: CustomEvent<DeckOnExceptionEventDetail>) => void;
  initialized?: (event: CustomEvent) => void;
};

export type WebStreamingProps = Pick<
  WebstreamingWebComponentProps,
  'active' | 'connected' | 'disconnected' | 'exception' | 'initialized'
>;

export type ShowroomInjectionProps = {
  onLoad: (result: boolean) => void;
  scriptSrc: string;
};
